import { Button, Dropdown, Modal, Image } from "react-bootstrap";
import "./userprofileheader.scss";
import statusmodalimage from "../../assets/images/status-modal-image.svg";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import deleteicon from "../../assets/images/delete-icon.svg";
import duplicatePlusIcon from "../../assets/images/duplicate-plus-icon.svg";
import deactivateicon from "../../assets/images/deactivate-icon.svg";
import resetpasswordicon from "../../assets/images/reset-password-icon.svg";
import loadicon from "../../assets/images/load-icon.svg";
import { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import useUser from "../../Hooks/useUser";
import { useNavigate } from "react-router-dom";
import Loading from "../LoadingPage/Loading";
import { toggleClass } from "../../utils/commonUtils";
import { DeleteConfModel } from "../DeleteConfModel/deleteConfModel";
import { toast } from "react-toastify";
import DublicateUserModel from "../DublicateUserModel/DublicateUserModel";
import { useModulePermissions, PermissionIdentifier, PermissionModule } from "../../utils/permissionUtils";

const UserProfileHeader = ({
  selectedUserData,
  updateStatus,
  currentUserId,
}: any) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showModal, setShowModal] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const { deleteUserAPI, deleteUserLoading } = useUser();
  const {
    getUserList,
    getUsersListLoading,
    duplicateUserLoading,
    onResetPassword,
    resetPasswordLoading,
  } = useUser();
  const navigate = useNavigate();
  const toggleModal = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const onClose = () => {
    toggleClass();
    setShowModal(!showModal);
  };
  const fetchUserList = () => {
    getUserList({
      searchText: "",
      active: true,
      sortColumn: "",
      sortDirection: ""
    }).then((res: any) => {
      if (res) {
        setUsersList(res);
      }
    });
  };
  const deleteUser = async () => {
    await deleteUserAPI({ id: selectedUserData.id, deletedBy: currentUserId });
    onClose();
    navigate("/users");
  };

  const resetPassword = async () => {
    const userName = selectedUserData.userName;
    const { result } = await onResetPassword({
      userName,
      updatedBy: currentUserId,
    });
    if (result) {
      toast.success(result);
    }
  };

  const toggleDuplicateModal = () => {
    toggleClass();
    setShowDuplicateModal(!showDuplicateModal);
  };

  const isPermitted = useModulePermissions(PermissionModule.USER_MANAGEMENT);
  const isEditPermitted = isPermitted(PermissionIdentifier.EDIT_USER);
  const isLoadUsagePermitted = isPermitted(PermissionIdentifier.LOAD_USAGE_USER);
  const isDuplicatePermitted = isPermitted(PermissionIdentifier.DUPLICATE_USER);
  const isDeletePermitted = isPermitted(PermissionIdentifier.DELETE_USER);
  const isInactivePermitted = isPermitted(PermissionIdentifier.INACTIVE_USER);
  const isResetPasswordPermitted = isPermitted(PermissionIdentifier.RESET_PASSWORD_USER);
  const isAnyActionPermitted = isLoadUsagePermitted || isDuplicatePermitted || isDeletePermitted || isInactivePermitted || isResetPasswordPermitted;

  useEffect(() => {
    fetchUserList();
  }, [])

  return (
    <div className="user-profile-header-wrapper">
      {deleteUserLoading || duplicateUserLoading || resetPasswordLoading || getUsersListLoading ? (
        <Loading />
      ) : null}
      <div className="profile-title-status-box">
        <h2>{selectedUserData.fName + " " + selectedUserData.lName}</h2>
        <div
          className={`status-box 
          ${selectedUserData?.isActive ? "active" : "inactive"}`}
        >
          <span className="status-circle"></span>
          <span className="status-text">
            {selectedUserData?.isActive ? "Active" : "Inactive"}
          </span>
        </div>
      </div>
      <div className="profile-actions-box">
        {isEditPermitted && (
          <div className="edit-btn-box">
            <Button variant="primary" href="/edit-user">
              <i className="bi bi-pencil-square"></i> Edit
            </Button>
          </div>
        )}
        <Dropdown>
          {isAnyActionPermitted && (
            <Dropdown.Toggle variant="link" id="dropdown-basic">
              <ReactSVG
                className="svg-box"
                wrapper="span"
                src={threedotvertical}
              />
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            {isLoadUsagePermitted && (
              <Dropdown.Item>
                <ReactSVG
                  style={{ marginLeft: "-3px" }}
                  className="svg-box"
                  wrapper="span"
                  src={loadicon}
                />
                Load Usage
              </Dropdown.Item>
            )}
            {isDuplicatePermitted && (
              <Dropdown.Item onClick={toggleDuplicateModal}
              // style={
              //   currentUserId === selectedUserData.id
              //     ? {
              //       pointerEvents: "none",
              //       opacity: 0.5,
              //     }
              //     : {}
              // }
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={duplicatePlusIcon}
                />
                Duplicate User
              </Dropdown.Item>
            )}
            {isDeletePermitted && (
              <Dropdown.Item onClick={toggleModal}
              // style={
              //   currentUserId === selectedUserData.id
              //     ? {
              //       pointerEvents: "none",
              //       opacity: 0.5,
              //     }
              //     : {}
              // }
              >
                <ReactSVG className="svg-box" wrapper="span" src={deleteicon} />
                Delete
              </Dropdown.Item>
            )}
            {isInactivePermitted && (
              <Dropdown.Item onClick={updateStatus}
              // style={
              //   currentUserId === selectedUserData.id
              //     ? {
              //       pointerEvents: "none",
              //       opacity: 0.5,
              //     }
              //     : {}
              // }
              >
                <ReactSVG
                  className="svg-box"
                  wrapper="span"
                  src={deactivateicon}
                />
                {selectedUserData?.isActive ? "Deactivate" : "Activate"}
              </Dropdown.Item>
            )}
            {isResetPasswordPermitted && (
              <Dropdown.Item onClick={resetPassword}>
                <ReactSVG
                  style={{ marginLeft: "-3px" }}
                  className="svg-box"
                  wrapper="span"
                  src={resetpasswordicon}
                />
                Reset Password
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Modal id="statusmodal" show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Image src={statusmodalimage} alt="" />
          <h4>
            Are you sure you want to <br></br>approve this user?
          </h4>
          <p>rachel.steward@test.com</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Approve
          </Button>
        </Modal.Footer>
      </Modal>
      <DeleteConfModel
        showModal={showModal}
        toggleModal={onClose}
        deleteAction={deleteUser}
        modelName={`User`}
        recordName={selectedUserData.email || ""}
      />
      <DublicateUserModel
        selectedUser={selectedUserData}
        showModal={showDuplicateModal}
        toggleDuplicateModal={toggleDuplicateModal}
        redirect={'/users'}
        userList={usersList}
      />
    </div>
  );
};

export default UserProfileHeader;
